export default "__VITE_ASSET__f9310f54__"